export default {"src":"/pro/_next/static/media/pol.ca045d0c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};